export class Cnpj {
  private readonly CNPJ_BLACKLIST = [
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999',
  ]

  private readonly STRICT_STRIP_REGEX = /[-\\/.]/g

  private readonly LOOSE_STRIP_REGEX = /[^\d]/g

  constructor(private readonly cnpj: string) {}

  private verifierDigit(digits: string): number {
    let index = 2
    const reverse: number[] = digits.split('').map(Number).reverse()

    const sum: number = reverse.reduce((buffer, number) => {
      buffer += number * index
      index = index === 9 ? 2 : index + 1
      return buffer
    }, 0)

    const mod: number = sum % 11
    return mod < 2 ? 0 : 11 - mod
  }

  private strip(number: string, strict?: boolean): string {
    const regex: RegExp = strict ? this.STRICT_STRIP_REGEX : this.LOOSE_STRIP_REGEX
    return (number || '').replaceAll(regex, '')
  }

  format(strict?: boolean): string {
    return this.strip(this.cnpj, strict).replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
  }

  validate() {
    if (!this.cnpj) return false

    const stripped = this.cnpj.replaceAll(/\D/g, '')

    if (stripped?.length === 14 && this.CNPJ_BLACKLIST.indexOf(stripped) === -1) {
      let numbers = stripped.substring(0, 12)
      numbers += this.verifierDigit(numbers)
      numbers += this.verifierDigit(numbers)

      if (numbers === stripped) {
        return true
      }
    }

    return false
  }
}
